module.exports = __webpack_public_path__ + "volum_circle4.png?79c7a1b34df061acd5dfacf56f1c9016";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volum_circle4.png
// module id = 706
// module chunks = 0